import $ from 'jquery';
import DDTemplates from 'dd-templates';

import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Footer from './Footer';
import Toolbar from './Toolbar';
import Gallery from './Gallery';
import MobileMenu from './MobileMenu';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';

import Pods from './Pods';
import Slider from './Slider';
import Banner from './Banner';
import Sponsors from './Sponsors';
import Redirect from './Redirect';
import RemoveLink from './RemoveLink';
import Placeholder from './Placeholder';
import DifferenceSlider from './DifferenceSlider';
import FeaturedSettings from './Settings.Featured';

// Add the theme behaviors

Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.fixNavigation) {
      element.fixNavigation = new FixNavigation(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.menu) {
      element.menu = new Menu(element);
      element.mobileMenu = new MobileMenu(element);
    }
  });

  // Hero Banner
  $('.banner.block', context).each((i, element) => {
    if (!element.banner) {
      element.banner = new Banner(element);
    }
  });

  // Featured
  $('#block-views_blocks-term-block_1-9', context).each((i, element) => {
    if (!element.featuredSlider) {
      element.featuredSlider = new Slider(element, FeaturedSettings);
    }
    if (!element.redirect) {
      element.redirect = new Redirect(element);
    }
  });

  // Home Pods
  $('#block-views_blocks-term-block_1-10', context).each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element);
    }
  });

  // Sponsors Section
  $('#block-views_blocks-term-block_1-11', context).each((i, element) => {
    if (!element.sponsors) {
      element.sponsors = new Sponsors(element);
    }
  });

  // Difference Slider
  $('#block-views_blocks-term-block_1-13', context).each((i, element) => {
    if (!element.differenceSlider) {
      element.differenceSlider = new DifferenceSlider(element);
    }
  });

  // Controls the states of the menu and search states
  $('.site-toolbar', context).each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).on('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, footer) => {
    const $footprint = $('.footprint', context);
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new Footer(footer, $footprint);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Pod Background Images
  $('.pods.block', context).each((i, element) => {
    if (!element.pods) {
      element.pods = new Pods(element);
    }
  });

  // Footer Links: Remove link from node header
  $('.headerband .node-header a', context).each((i, element) => {
    if (!element.removeLink) {
      element.removeLink = new RemoveLink(element);
    }
  });

  // Footer Links: Remove link from node header
  $('.footer.links .node-header a', context).each((i, element) => {
    if (!element.removeLink) {
      element.removeLink = new RemoveLink(element);
    }
  });

  // Footer Links: Remove link from node header
  $('.footer.signup .type-textfield', context).each((i, element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.calendarFeed) {
      element.calendarFeed = new CalendarFeed(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});



// WEBPACK FOOTER //
// ./theme.js